var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout.type === 'media-middle')?_c('div',{staticClass:"RMPE-DynamicField-Media"},[(_vm.layout.image !== null)?_c('img',{attrs:{"src":_vm.layout.image,"alt":""}}):(_vm.layout.video !== null)?_c('VideoEmbed',{attrs:{"url":_vm.layout.video}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }